/**
 * Metric card for displaying key statistics
 */

import React from 'react'

interface StatsCardProps {
  value: string
  label: string
  sublabel?: string
  color?: string
}

export const StatsCard: React.FC<StatsCardProps> = ({
  value,
  label,
  sublabel,
  color,
}) => {
  return (
    <div className="bg-tertiary rounded-lg p-4 flex-1 min-w-[120px]">
      <div
        className="text-2xl font-bold"
        style={{ color: color || 'var(--color-text-primary)' }}
      >
        {value}
      </div>
      <div className="text-sm text-primary font-medium">{label}</div>
      {sublabel && <div className="text-xs text-secondary mt-0.5">{sublabel}</div>}
    </div>
  )
}

export default StatsCard
